import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const STATS = [
  { value: "3", key: "about.stat1" },
  { value: "12+", key: "about.stat2" },
  { value: "1", key: "about.stat3" },
];

export default function Manifesto() {
  const { t } = useLang();

  return (
    <section id="about" data-testid="about-section" className="relative scroll-mt-24 overflow-hidden py-28 md:py-40">
      <div className="pointer-events-none absolute right-0 top-0 -z-10 h-96 w-96 rounded-full bg-flame/10 blur-[140px]" />
      <div className="mx-auto max-w-5xl px-5 md:px-8">
        <div className="flex flex-col gap-12 md:flex-row md:items-center md:gap-16">
          <motion.div
            initial={{ opacity: 0, rotate: -8, y: 40 }}
            whileInView={{ opacity: 1, rotate: -3, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative mx-auto w-52 shrink-0 md:mx-0 md:w-64"
          >
            <img
              src="/mascot-color.png"
              alt="KNDLA mascot — a little candle ghost"
              data-testid="about-mascot"
              className="w-full rounded-2xl border border-white/10"
            />
            <span className="flame-glow absolute -right-3 -top-3 rotate-6 rounded-full bg-flame px-3 py-1 font-syne text-[10px] font-extrabold uppercase tracking-widest text-white">
              The boss
            </span>
          </motion.div>
          <div>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="text-xs font-bold uppercase tracking-[0.35em] text-flame"
            >
              {t("about.eyebrow")}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-6 font-syne text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl"
            >
              {t("about.titleA")}
              <span className="text-flame">{t("about.titleB")}</span>
              {t("about.titleC")}
              <span className="text-outline">{t("about.titleD")}</span>
              {t("about.titleE")}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.25 }}
              className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg"
            >
              {t("about.body")}
            </motion.p>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="mt-14 grid gap-8 border-t border-white/10 pt-10 sm:grid-cols-3"
        >
          {STATS.map((s) => (
            <div key={s.key}>
              <div className="font-syne text-5xl font-extrabold text-flame">{s.value}</div>
              <div className="mt-2 text-sm text-white/50">{t(s.key)}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
